import styled from 'styled-components';
import { divider } from '../styles/abstracts/mixins';

export const Divider = styled.div`
  ${divider}
`;

export default Divider;
